import { updateUserLocationPatch } from '@/services/api/requests/user';
import { TUser, TUserLocation } from '@/types/User.types';
import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';

const useUpdateLocation = (onSuccessCallback: (user: TUser) => void) => {
  const toast = useToast();

  const { isSuccess, isPending, mutate } = useMutation({
    mutationFn: async (location: TUserLocation) => {
      const response = await updateUserLocationPatch(location);
      return response;
    },
    onSuccess: (user: TUser) => {
      toast({
        status: 'success',
        title: 'Success',
        description: 'User Location successfully updated.',
      });

      onSuccessCallback?.(user);
    },
    onError: () => {},
  });

  return { isPending, isSuccess, mutate };
};

export default useUpdateLocation;
